import React from 'react';
import PropTypes from 'prop-types';

const { numeral } = window;
const decimalPattern = /^\d*[\.,]?\d*$/;

class NumberInput extends React.Component {
    static propTypes = {
        value: PropTypes.number.isRequired,
        formatter: PropTypes.func,
        clearInputOnFocus: PropTypes.bool,
        selectInputOnFocus: PropTypes.bool,
        className: PropTypes.string,
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onKeyDown: PropTypes.func,
    };

    static defaultProps = {
        formatter: undefined,
        clearInputOnFocus: false,
        selectInputOnFocus: false,
        className: undefined,
        onChange: undefined,
        onFocus: undefined,
        onBlur: undefined,
        onKeyDown: undefined,
    };

    constructor() {
        super();

        this.state = {
            value: 0,
            edit_value: '0',
            display_value: '0',
            is_focused: false,
        };
    }

    inputRef = null;

    componentDidMount() {
        this.setValue(this.props.value);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setValue(nextProps.value);
        }
    }

    setValue(value, callback) {
        const formattedValue = numeral(value).format('0.[00]');
        this.setState(
            {
                value,
                edit_value: formattedValue,
                display_value: this.props.formatter
                    ? this.props.formatter(value)
                    : formattedValue,
            },
            callback
        );
    }

    onInputFocus = e => {
        const { target } = e;
        this.setState(
            {
                is_focused: true,
                edit_value: this.props.clearInputOnFocus
                    ? ''
                    : this.state.edit_value,
            },
            () => {
                if (this.props.selectInputOnFocus) {
                    target.select();
                }
            }
        );
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    };

    onInputBlur = e => {
        const parsedValue = numeral(this.state.edit_value);
        this.setValue(
            parsedValue.value() !== null
                ? parsedValue.value()
                : this.state.value,
            () => {
                if (this.props.onChange) {
                    this.props.onChange(this.state.value);
                }
            }
        );
        this.setState({ is_focused: false });
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    };

    onInputChange = e => {
        if (decimalPattern.test(e.target.value)) {
            this.setState({ edit_value: e.target.value });
        }
    };

    forceBlur = () => {
        if (this.inputRef) {
            this.inputRef.blur();
        }
    };

    render() {
        const { display_value, edit_value, is_focused } = this.state;
        return (
            <input
                ref={ref => (this.inputRef = ref)}
                className={this.props.className}
                type="text"
                onFocus={this.onInputFocus}
                onBlur={this.onInputBlur}
                onChange={this.onInputChange}
                onKeyDown={this.props.onKeyDown}
                value={is_focused ? edit_value : display_value}
            />
        );
    }
}

export default NumberInput;
